import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@material-ui/styles';
import { MDSIcon, MDSTypography, MDSPlainButton } from '@marqvision/mds-v2';

const useStyles = makeStyles(({ color }) => ({
  wrapper: {
    padding: '12px 16px',
    borderRadius: '8px',
    border: `1px solid ${color.border.neutral.default.normal}`,
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '8px',
    cursor: 'pointer',
  },
  body: {
    display: 'grid',
    gridTemplateRows: '0fr',
    paddingTop: '0px',
    transition: '0.3s',
    '&.isShow': {
      gridTemplateRows: '1fr',
    },
  },
  box: {
    overflow: 'hidden',
  },
  content: {
    paddingTop: '12px',
    display: 'flex',
    flexDirection: 'column',
    gap: '8px',
  },
}));

type Props = {
  title: string;
};

//TODO-@morgan: remove. MDSExpansion 생기면 그걸로 대체
export const Accordion = (props: React.PropsWithChildren<Props>) => {
  const { title, children } = props;
  const classes = useStyles();

  const [isShow, setIsShow] = useState<boolean>(false);

  const label = isShow ? 'Hide' : 'Show';
  const color = isShow ? 'bluegray' : 'blue';
  const EndIcon = isShow ? MDSIcon.ArrowUp : MDSIcon.ArrowDown;

  const toggleShow = () => {
    setIsShow((prev) => !prev);
  };

  return (
    <div className={classes.wrapper}>
      <label className={classes.header}>
        <MDSTypography variant="body" size="m" weight="medium">
          {title}
        </MDSTypography>
        <MDSPlainButton size="small" color={color} endIcon={<EndIcon variant="outline" />} onClick={toggleShow}>
          {label}
        </MDSPlainButton>
      </label>
      <div className={clsx(classes.body, { isShow })}>
        <div className={classes.box}>
          <div className={classes.content}>{children}</div>
        </div>
      </div>
    </div>
  );
};
